import { appActions } from '@app';
import { Button } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ADMIN_DASHBOARD_COPY, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { useAction, useLogout } from '@hooks';

export const AdminDashboardNavigation: React.FC = () => {
	const navigate = useNavigate();
	const softReset = useAction(appActions.softResetApplication);

	const handleReturnToDashboard = () => {
		softReset();
		navigate(FULL_ROUTES.DASHBOARD);
	};

	const handleLogout = useLogout();

	return (
		<div className='button-panel'>
			<Button
				id='btn-return-dashboard'
				onClick={ handleReturnToDashboard }
				type='primary'>
				{ ADMIN_DASHBOARD_COPY.RETURN_TO_DASHBOARD }
			</Button>
			<Button
				id='btn-log-out'
				onClick={ handleLogout }
				type='primary'>
				{ ADMIN_DASHBOARD_COPY.LOG_OUT }
			</Button>
		</div>
	);
};
